import { BaseServerData, IRestoreData } from '../base/IData';
import { WinGameData } from "./WinGameData";
import { ReelGameData } from "./ReelGameData";
import { SanGameMode } from "../../config/base/GameConfig";

export class GameData {
    public raw: BaseServerData;
    public Win: WinGameData;
    public Reel: ReelGameData;
    private _fsStartAmount: number;

    public get isRestoreState(): boolean {
        return this.raw.isRestoreState;
    }

    public get FirstAmplify(): boolean {
        return (this.raw.boostedBet || this.raw.featureBuy) && this.isNormalMode;
    }

    public get FirstBonusBuy(): boolean {
        return (this.raw.featureBuy) && this.isNormalMode;
    }


    public get mode(): string {
        return this.raw.mode;
    }

    public get nextMode(): string {
        return this.raw.nextMode;
    }

    public get fsStartAmount(): number {
        return this._fsStartAmount;
    }

    public get fsRestoreData(): IRestoreData {
        return this.raw.restoreData ?? {} as IRestoreData;
    }

    public get isNormalMode(): boolean {
        return this.isMode(SanGameMode.NORMAL);
    }

    public get isFreeSpin(): boolean {
        return this.isMode(SanGameMode.FREESPIN);
    }

    public get isFirstFSSetup(): boolean {
        return this.isMode(SanGameMode.FREESPIN_SETUP1);
    }

    public get isSecondSetup(): boolean {
        return this.isMode(SanGameMode.FREESPIN_SETUP2) || this.isNextMode(SanGameMode.FREESPIN_SETUP2);
    }

    public get isFSSetup(): boolean {
        return this.isMode(SanGameMode.FREESPIN_SETUP1) || this.isMode(SanGameMode.FREESPIN_SETUP2);
    }

    public get nextIsFSSetup(): boolean {
        return this.isNextMode(SanGameMode.FREESPIN_SETUP1);
    }

    public get nextIsRespin(): boolean {
        return this.isNextMode("RESPIN");
    }

    public get nextModeIsNormal(): boolean {
        return this.isNextMode(SanGameMode.NORMAL);
    }

    public get lastFSRound(): boolean {
        return (this.isMode(SanGameMode.FREESPIN) || this.isMode(SanGameMode.FREESPIN_SUPER)) && this.isNextMode(SanGameMode.NORMAL);
    }

    public get isNextFS(): boolean {
        return !this.isFreeSpin && this.isNextMode(SanGameMode.FREESPIN);
    }

    public get gameModeChanges(): boolean {
        return this.mode !== this.nextMode;
    }

    constructor() {
        this.Reel = new ReelGameData();
        this.Win = new WinGameData();
    }

    public setData(data: BaseServerData): void {
        this.raw = data;
        this.Reel.apply(data);
        this.Win.apply(data);
    }

    private isMode(mode: string): boolean {
        return this.mode === mode;
    }

    private isNextMode(mode: string): boolean {
        return this.nextMode === mode;
    }
}